export const MAX_EXCEPTION_MESSAGE_LENGTH = 2000

function truncate(message) {
  if (typeof message !== "string" || message.length <= MAX_EXCEPTION_MESSAGE_LENGTH) return message

  return `${message.slice(0, MAX_EXCEPTION_MESSAGE_LENGTH)}… [truncated ${message.length - MAX_EXCEPTION_MESSAGE_LENGTH} chars]`
}

function truncateExceptionValue(exception) {
  return "value" in exception ? { ...exception, value: truncate(exception.value) } : exception
}

export function truncateExceptionMessages(event) {
  if (event?.event !== "$exception" || !event.properties) return event

  const { properties } = event
  if (Array.isArray(properties.$exception_list)) {
    properties.$exception_list = properties.$exception_list.map(truncateExceptionValue)
  }
  if ("$exception_message" in properties) properties.$exception_message = truncate(properties.$exception_message)

  return event
}
